"use client";

import CaptureInput from "@/components/CaptureInput";
import type { CaptureResponse, CaptureRouteState } from "@/lib/api";

interface Props {
  onSubmit: (text: string) => Promise<void>;
  onScreenshotRouted?: (text: string, routeState: CaptureRouteState) => Promise<void>;
  onScreenshotCapture?: (response: CaptureResponse) => void;
  onError?: (message: string) => void;
  focusSignal?: number;
}

export default function QuickCaptureBar({
  onSubmit,
  onScreenshotRouted,
  onScreenshotCapture,
  onError,
  focusSignal = 0,
}: Props) {
  return (
    <section data-testid="capture-input">
      <p className="mb-2 text-[10px] font-semibold uppercase tracking-[0.16em] text-muted">
        Quick capture
      </p>
      <CaptureInput
        onSubmit={onSubmit}
        onScreenshotRouted={onScreenshotRouted}
        onScreenshotCapture={onScreenshotCapture}
        onError={onError}
        placeholder="Capture what is on your mind..."
        focusSignal={focusSignal}
      />
    </section>
  );
}
